// extracted by mini-css-extract-plugin
module.exports = {"container":"ShortMenuAction_container__38KPA","text":"ShortMenuAction_text__24H8P","picto":"ShortMenuAction_picto__AjLPr"};